import { render, staticRenderFns } from "./translation-setting.vue?vue&type=template&id=af3551d4&"
import script from "./translation-setting.ts?vue&type=script&lang=ts&"
export * from "./translation-setting.ts?vue&type=script&lang=ts&"
import style0 from "./translation-setting.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports